module.exports = __webpack_public_path__ + "img/speak5.edb55fed.png";